import gql from 'graphql-tag';

const DELETE_DOCUMENT_TEMPLATE_MUTATION = gql`
  mutation deleteDocumentTemplate($_id: ID!) {
    deleteDocumentTemplate(_id: $_id)
  }
`;

export default DELETE_DOCUMENT_TEMPLATE_MUTATION;
